import { useEffect } from 'react';

/**
 * Хук для динамического обновления заголовка страницы
 * @param {string} title - Новый заголовок страницы
 * @param {boolean} includeDefault - Включать ли стандартный суффикс
 */
export const useDocumentTitle = (title, includeDefault = true) => {
  useEffect(() => {
    const defaultTitle = 'ZARA в Россию через buyer_olesia';
    const newTitle = includeDefault ? `${title} | ${defaultTitle}` : title;
    
    document.title = newTitle;
    
    // Также обновляем Open Graph заголовок для социальных сетей
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', newTitle);
    }
    
    // Обновляем Twitter заголовок
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', newTitle);
    }
    
    // Восстанавливаем заголовок при размонтировании компонента
    return () => {
      document.title = defaultTitle;
      if (ogTitle) {
        ogTitle.setAttribute('content', defaultTitle);
      }
      if (twitterTitle) {
        twitterTitle.setAttribute('content', defaultTitle);
      }
    };
  }, [title, includeDefault]);
};
